module.exports = __webpack_public_path__ + "assets/3ccb7e51f9bdf5fcc97a17a84212cf14.jpg";